<nav class="navigation">
  <ul class="nav-list">
    @for (route of filteredRoutes; track route.path) {
      <li class="nav-item">
        <a
          [routerLinkActiveOptions]="{ exact: false }"
          [routerLink]="['/settings', route.path]"
          routerLinkActive="active"
          class="nav-link"
        >
          <dx-text type="pb-bold">
            {{ "navigation.settings-route." + route.path | transloco }}
          </dx-text>
        </a>
      </li>
    }
  </ul>
</nav>
